import { render } from "./drainage-popup.vue?vue&type=template&id=5d3b9774&scoped=true"
import script from "./drainage-popup.vue?vue&type=script&lang=js"
export * from "./drainage-popup.vue?vue&type=script&lang=js"

import "./drainage-popup.vue?vue&type=style&index=0&id=5d3b9774&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3b9774"]])

export default __exports__